module.exports = __webpack_public_path__ + "static/coppers-47bc8a130af854bfe9bcfa36cf39ab55.png";